import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import config from 'config/config';
import { useCookieConsent } from 'context/CookieConsentContext';

// Vendor-agnostic scaffold: point REACT_APP_CHAT_WIDGET_URL at whichever
// live-chat provider's embeddable iframe URL is chosen. Left unset, this
// renders nothing - no chat vendor is wired up yet.
const ChatWidgetButton = () => {
  const theme = useTheme();
  const { analyticsGranted } = useCookieConsent();
  const [open, setOpen] = useState(false);

  if (!config.CHAT_WIDGET_URL || !analyticsGranted) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: theme.spacing(3),
        right: theme.spacing(3),
        zIndex: theme.zIndex.snackbar,
      }}
    >
      {open ? (
        <Box
          sx={{
            width: 340,
            height: 480,
            maxWidth: '90vw',
            maxHeight: '70vh',
            boxShadow: theme.shadows[8],
            borderRadius: 1,
            overflow: 'hidden',
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <IconButton
              aria-label="Close chat"
              onClick={() => setOpen(false)}
              size="small"
              sx={{ color: theme.palette.primary.contrastText }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box
            component="iframe"
            title="Live chat"
            src={config.CHAT_WIDGET_URL}
            sx={{ flex: 1, border: 0 }}
          />
        </Box>
      ) : (
        <Fab
          color="primary"
          aria-label="Open chat"
          onClick={() => setOpen(true)}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      )}
    </Box>
  );
};

export default ChatWidgetButton;
